// angular import
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// project import
import { NavBarComponent } from './toolbar.component';
import { NavLeftComponent } from './toolbar-left/toolbar-left.component';
import { NavRightComponent } from './toolbar-right/toolbar-right.component';
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { RouterModule } from '@angular/router';
import { NotificationsComponent } from "src/app/tabms/components/global/notifications/notifications.component";

@NgModule({
  declarations: [NavBarComponent, NavLeftComponent, NavRightComponent],
  imports: [CommonModule, SharedModule, RouterModule, NotificationsComponent],
  exports: [NavBarComponent,NavRightComponent]
})
export class NavBarModule {}
